import React from "react";
import { Link } from "react-router-dom";

function GetInTouch() {
  return (
    <section className="touch-section">
      <div className="touch-container">
        {/* Heading */}
        <div className="touch-heading">
          <h3>We’re Here to Help</h3>
          <p>
            Reach out to us anytime — our team is always ready to assist you
            with product inquiries, order support, or general information.
          </p>
        </div>

        {/* Contact Cards */}
        <div className="touch-grid">
          {/* Address */}
          <div className="touch-card">
            <div className="touch-icon">
              <i className="fa-solid fa-location-dot"></i>
            </div>
            <h5 className="touch-title">Our Address</h5>
            <p className="touch-text">
              520 Juliette Way Apt 5409 Cedar Park, Tx 78613
            </p>
          </div>

          {/* Phone */}
          <div className="touch-card">
            <div className="touch-icon">
              <i className="fa-solid fa-phone"></i>
            </div>
            <h5 className="touch-title">Phone Number</h5>
            <p className="touch-text">
              <Link to="tel:+15127447593">+1-512-744-7593</Link>
            </p>
          </div>

          {/* Email */}
          <div className="touch-card">
            <div className="touch-icon">
              <i className="fa-solid fa-envelope"></i>
            </div>
            <h5 className="touch-title">Email Address</h5>
            <p className="touch-text">
              <Link to="mailto:info@howlywizard.com">info@howlywizard.com</Link>
            </p>
          </div>
        </div>
      </div>

      {/* === INLINE STYLE === */}
      <style>{`
        .touch-section {
          padding: 70px 0;
          background: #f7f8fc;
        }

        .touch-container {
          max-width: 1250px;
          margin: auto;
          padding: 0 20px;
        }

        .touch-heading {
          text-align: center;
          max-width: 650px;
          margin: 0 auto 50px;
        }

        .touch-heading h3 {
          font-size: 32px;
          font-weight: 800;
          margin-bottom: 12px;
          color: #1a1a1a;
        }

        .touch-heading p {
          color: #666;
          font-size: 15px;
          line-height: 1.7;
        }

        /* Grid Layout */
        .touch-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(290px, 1fr));
          gap: 28px;
        }

        /* Card */
        .touch-card {
          background: #ffffffaa;
          border: 1px solid #e4e7ef;
          padding: 30px 25px;
          border-radius: 16px;
          backdrop-filter: blur(6px);
          transition: 0.3s ease;
          text-align: center;
        }

        .touch-card:hover {
          box-shadow: 0 12px 22px rgba(0,0,0,0.08);
          transform: translateY(-6px);
          border-color: #d7def2;
        }

        /* Icon Circle */
        .touch-icon {
          width: 60px;
          height: 60px;
          background: #e9f1ff;
          color: #0b61d6;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 18px;
          border-radius: 50%;
          font-size: 22px;
          position: relative;
        }

        .touch-icon::after {
          content: "";
          position: absolute;
          width: 78px;
          height: 78px;
          border-radius: 50%;
          border: 2px dashed #d6e5ff;
          top: -9px;
          left: -9px;
        }

        .touch-title {
          font-size: 18px;
          font-weight: 700;
          color: #222;
          margin-bottom: 10px;
        }

        .touch-text {
          font-size: 14px;
          color: #555;
          line-height: 1.6;
        }

        .touch-text a {
          color: #0b61d6;
          text-decoration: none;
          font-weight: 600;
        }

        .touch-text a:hover {
          text-decoration: underline;
        }

      `}</style>
    </section>
  );
}

export default GetInTouch;
